import { useTheme } from '@emotion/react';
import { useEffect, useState } from 'react';
import { Link } from '../styled/Link';
import { DEVICE_SCREENS_MAX_STRING } from '../../lib/consts';
import { http } from '../../lib/api/http';
import { V2 } from '../../lib/api/urls';
import { ConfigTypes } from '../../models/config';
import { Page } from '../../models';

export default function CookieAgreementModal() {
  const [showPopUp, setShowPopUp] = useState(false);
  const [agreementPage, setAgreementPage] = useState<null | Page>(null);
  const theme = useTheme();

  useEffect(() => {
    const userAgreed = Number(localStorage.getItem('user-agree-term')) === 1;
    if (!userAgreed) {
      if (sessionStorage.getItem('agreementPage')) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        setAgreementPage(JSON.parse(sessionStorage.getItem('agreementPage')));
      } else {
        http.get(V2.config, {}).then((config: ConfigTypes) => {
          const showCookieWarningRequest = !!config.find(
            (item) => item.name === 'SHOW_COOKIE_WARNING'
          )?.value;
          http
            .get(V2.pages, { unique_content: 'agreement' })
            .then((pages: { results: Page[] }) => {
              if (pages.results.length > 0 && showCookieWarningRequest) {
                setAgreementPage(pages.results[0]);
                sessionStorage.setItem(
                  'agreementPage',
                  JSON.stringify(pages.results[0])
                );
              }
            });
        });
      }
    }
  }, []);

  useEffect(() => {
    if (agreementPage) {
      setShowPopUp(true);
    }
  }, [agreementPage]);

  if (!showPopUp) {
    return null;
  }
  return (
    <div
      css={{
        fontFamily: 'Golos',
        fontSize: 14,
        display: 'flex',
        alignItems: 'center',
        position: 'fixed',
        bottom: 20,
        right: 20,
        zIndex: '9999',
        padding: 20,
        gap: 20,
        background: '#2c3135',
        width: 460,
        maxWidth: 'calc(100% - 40px)',
        borderRadius: 20,
        [DEVICE_SCREENS_MAX_STRING.md]: {
          right: 8,
          maxWidth: 'calc(100% - 16px)',
        },
      }}
    >
      <div css={{ color: theme.colors.white }}>
        На сайте используются cookies. Продолжая использовать сайт вы принимаете
        условия{' '}
        <Link
          href={`/pages/${agreementPage?.slug}/`}
          css={{ color: '#F44336', ':hover': { color: '#FF4A2E' } }}
        >
          пользовательского соглашения
        </Link>
      </div>
      <button
        type='button'
        css={{
          width: 200,
          height: 50,
          background: '#FF4A2E',
          cursor: 'pointer',
          color: theme.colors.white,
          borderRadius: 16,
        }}
        onClick={() => {
          localStorage.setItem('user-agree-term', '1');
          setShowPopUp(false);
        }}
      >
        ОК
      </button>
    </div>
  );
}
